import { render, staticRenderFns } from "./myqustion.vue?vue&type=template&id=3ccf62ac&scoped=true&"
import script from "./myqustion.vue?vue&type=script&lang=ts&"
export * from "./myqustion.vue?vue&type=script&lang=ts&"
import style0 from "./myqustion.vue?vue&type=style&index=0&id=3ccf62ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf62ac",
  null
  
)

export default component.exports